import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Login } from "./pages/Login";
import { Signup } from "./pages/Signup";
import { Dashboard } from "./pages/Dashboard";
import { Toaster } from "./components/ui/sonner";

function CurriculumRedirect() {
  const { curriculumId } = useParams();
  return <Navigate to={`/dashboard?tab=curriculum&curriculumId=${encodeURIComponent(curriculumId || "")}`} replace />;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          {/* Deep link for ENGG-1886. The dashboard renders this as the
              `cleverlms` tab via the `?tab=` query parameter. */}
          <Route
            path="/clever-lms"
            element={<Navigate to="/dashboard?tab=cleverlms" replace />}
          />
          <Route path="/curriculum" element={<Navigate to="/dashboard?tab=curriculum" replace />} />
          <Route path="/curriculum/:curriculumId" element={<CurriculumRedirect />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
